import { graphql } from '../../../graphql/generated';

export const UPDATE_DOCTOR_MUTATION = graphql(`
  mutation UpdateDoctor($id: ID!, $input: DoctorInput!) {
    updateDoctor(id: $id, input: $input) {
      id
    }
  }
`);

export const DoctorFragment = graphql(`
  fragment UpdateDoctorModal_Doctor on Doctor {
    id
    salutation
    preTitle
    postTitle
    firstName
    lastName
    name
    specialist
    meAddress
    hvNumber
    street
    zip
    city
    email
    phone
    assignedLabs {
      lab {
        id
        name
      }
      customerId
      supplier
      runningNumber
    }
    comment
    aisImportType
    aisImportDoctorId
    billingPreference
    preferSpecialRate
    autoDiagnose
    autoSpecialRate
    catalogs {
      id
      name
      lab {
        id
        shortName
      }
    }
    tags {
      id
      name
      color
    }
    insurances {
      id
    }
    specialRates {
      id
      maxUsagesPerPeriod
      specialRate {
        id
      }
    }
    doctorBilling
    patientBilling
    lgInsurances {
      id
    }
    lgDoctorBilling
    hasAis
    printTransferDocument
    showPrices
    showPriceSuggestion
    flipParamNames
    aisExportTypes
    addEmptyLabels
    theme {
      id
      name
    }
    csvImportEnabled
    overrideRequestEnabled
    disabled
    ecardEnabled
    aiEnabled
    aiMonthlyTokenQuota
    aiPackage
    aiBillingLabId
    installDate
    zplLabelTemplate
    zplLabelHeight
    zplLabelWidth
    addZplLabels
    phoneContacts {
      id
      name
      phoneNumber
    }
    assignedUserCount
    aisLinks {
      vendor
      externalId
    }
    hasAisLink
  }
`);
